import script from "./AlbumsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumsView.vue?vue&type=script&setup=true&lang=js"

import "./AlbumsView.vue?vue&type=style&index=0&id=fd388edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd388edc"]])

export default __exports__